import * as Yup from 'yup'

const passwordField = Yup.string()
    .min(5, 'Ingresa una contraseña válida. Longitud mínima 5 caracteres')
    .max(8, 'Ingresa una contraseña válida. Longitud máxima 8 caracteres ')
    .matches(/[+*!.$#&@_-]/, 'La contraseña debe contener uno o más caracteres especiales: +*!.$#&@_-')
    .required('La contraseña es requerida')
const passwordRepeatField = Yup.string()
    .oneOf([Yup.ref('password'), ''], 'Las contraseñas ingresadas no coinciden entre sí')
    .required('Es necesario repetir la contraseña')
const actualPasswordField = Yup.string()
    .required('La contraseña actual es requerida')
    .min(5, 'La contraseña actual no es válida. Longitud mínima 5 caracteres')
    .max(8, 'La contraseña actual no es válida. Longitud máxima 8 caracteres ')
    .matches(/[+*!.$#&@_-]/, 'La contraseña actual debe contener uno o más caracteres especiales: +*!.$#&@_-')

const RecoverPasswordValidationSchema = Yup.object().shape({
    password: passwordField,
    passwordRepeat: passwordRepeatField
})

const ChangePasswordValidationSchema = Yup.object().shape({
    password: passwordField,
    passwordRepeat: passwordRepeatField,
    actualPassword: actualPasswordField
})

export default (isChangePassword: boolean) => {
   return isChangePassword ? ChangePasswordValidationSchema : RecoverPasswordValidationSchema
}
